<template>
  <ContactsTable
    class="company-recruiter-data-table"
    :contacts="entries"
    :no-results-message="$t('No results')"
    :all-contacts-name="$t('Show all recruitment agencies')"
    :search-placeholder="$t('Search recruitment agency')"
    :loading="loading"
    :with-email="false"
    :without-fee="manageWorkers === true"
    :with-ownership="true"
    :with-tags="true"
  >
    <template #Name="{ row, rowIndex }">
      <WdsStack align-center gap-md>
        <ProfileInfoCard :global-id="row.id">
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <WdsAvatar :path="getAvatarPath(row.avatar, row.id)" />
        </ProfileInfoCard>
        <div>
          <WdsStack direction-column>
            <div>
              <strong class="f-500" :data-test="`recruiter-name-${rowIndex}`">
                <a v-if="row.profileUrl" :href="row.profileUrl">
                  {{ row.name }}
                </a>
                <span v-else>
                  {{ row.name }}
                </span>
              </strong>
            </div>
            <div :data-test="`recruiter-email-${rowIndex}`">
              {{ row.email }}
            </div>
          </WdsStack>
        </div>
      </WdsStack>
    </template>
    <template #Fee="{ row, rowIndex }">
      <span :data-test="`recruiter-fee-${rowIndex}`">{{ row.fee.toFixed(2) }} %</span>
    </template>
    <template #Ownership="{ row, rowIndex }">
      <div class="tw-capitalize" :data-test="`recruiter-ownership-days-${rowIndex}`">
        {{ row.ownership ?? '-' }}
      </div>
    </template>
    <template #Status="{ row, rowIndex }">
      <WdsTag
        sm
        :success="row.status === 'active'"
        :warning="row.status === 'invited'"
        :data-test="`recruiter-status-${rowIndex}`"
      >
        {{ $t(row.status) }}
      </WdsTag>
    </template>
    <template #Tags="{ row, rowIndex }">
      <WdsTagGroup
        :tags="formattedTags(row.tags)"
        sm
        :max-tags="maxTags"
        :data-test="`recruiter-tags-${rowIndex}`"
      />
    </template>
    <template
      #editAction="{ rowIndex, pivotId, freelancerName, freelancerEmail, fee, ownership, tags }"
    >
      <div :data-test="`edit-recruiter-button-${rowIndex}`">
        <EditCompanyRecruiter
          :company-recruiter-id="pivotId"
          :name="freelancerName"
          :email="freelancerEmail"
          :recruiter-fee="fee"
          :recruiter-ownership-days="ownership"
          :tags="tags"
        />
      </div>
    </template>

    <template #deleteAction="{ contactId, rowIndex }">
      <DeleteCompanyRecruiter
        :company-recruiter-id="contactId"
        :data-test="`delete-recruiter-button-${rowIndex}`"
        @deleted="$emit('updated')"
      />
    </template>
  </ContactsTable>
</template>

<script>
import { WdsStack, WdsTag, WdsTagGroup } from '@worksome/wds-components'
import ContactsTable from '@/components/Contacts/ContactsTable.vue'
import EditCompanyRecruiter from '@/components/Contacts/CompanyRecruiter/EditCompanyRecruiter.vue'
import DeleteCompanyRecruiter from '@/components/Contacts/CompanyRecruiter/DeleteCompanyRecruiter.vue'
import ProfileInfoCard from '@/components/ProfileInfoCard.vue'
import { getAvatarPath } from '@/utils/avatar'

export default {
  name: 'CompanyRecruiterContacts',
  components: {
    ProfileInfoCard,
    DeleteCompanyRecruiter,
    EditCompanyRecruiter,
    ContactsTable,
    WdsTagGroup,
    WdsTag,
    WdsStack,
  },
  props: {
    entries: {
      type: Array,
      default: [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    maxTags: {
      type: Number,
      default: 3,
    },
    manageWorkers: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contacts: [],
    }
  },
  methods: {
    getAvatarPath,
    formattedTags(tags) {
      return tags?.map((tag) => ({
        label: tag,
        primary: false,
      }))
    },
  },
}
</script>

<style scoped lang="scss">
.company-recruiter-data-table:deep {
  .data-table-head {
    padding-right: 0;
    padding-left: 0;

    // Allows multiselect to show full text
    .multi-select .btn .pull-left {
      @apply tw-max-w-none;
    }

    // Sets width of multiselect and aligns with Header and edge of table
    .multi-select .locked-width {
      @apply tw-w-60;
    }
  }
}
</style>
